module.exports = __webpack_public_path__ + "static/img/14000105.afc24560.png";